/**
 * custom.js — ストア固有のカスタム JavaScript（Dawn のカスタム層に相当）
 *
 * theme.js の直後に読み込まれます。テーマ本体は変更せず、上書き・追加はここに置く。
 */

document.querySelectorAll('a[href^="http"]').forEach(function (link) {
  if (!link.href.includes(location.hostname)) {
    link.setAttribute('target', '_blank');
    link.classList.add('blank');
  }
});

if (window.theme && window.theme.settings && window.theme.settings.respect_reduced_motion && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.documentElement.classList.add('reduce-motion');
}

function initTransparentHeader() {
  var header = document.querySelector('[data-theme-section="header"]');

  if (!header) {
    return;
  }

  var sectionSettings = {};

  try {
    sectionSettings = JSON.parse(header.getAttribute('data-section-settings') || '{}');
  } catch (error) {
    sectionSettings = {};
  }

  if (!sectionSettings.hasTransparentHeader) {
    return;
  }

  var scrollThreshold = 10;

  function updateTransparentHeader() {
    if (window.scrollY > scrollThreshold) {
      header.classList.remove('header--transparent');
    } else {
      header.classList.add('header--transparent');
    }
  }

  updateTransparentHeader();
  window.addEventListener('scroll', updateTransparentHeader, { passive: true });
  window.addEventListener('pageshow', updateTransparentHeader);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTransparentHeader);
} else {
  initTransparentHeader();
}

function revealStaticContent() {
  document.querySelectorAll('.article-item').forEach(function (item) {
    item.classList.add('is-visible');
    item.style.visibility = 'visible';
    item.style.opacity = '1';
  });

  document.querySelectorAll('.slideshow__slide.is-selected').forEach(function (slide) {
    slide.style.visibility = 'visible';
    slide.style.opacity = '1';
  });

  document.querySelectorAll('.slideshow__image').forEach(function (image) {
    image.style.opacity = '1';
  });

  document.querySelectorAll('.image--fade-in').forEach(function (image) {
    image.style.opacity = '1';
  });

  document.querySelectorAll('.product__media-item img').forEach(function (image) {
    image.style.opacity = '1';
    image.style.transform = 'none';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', revealStaticContent);
} else {
  revealStaticContent();
}

window.addEventListener('load', revealStaticContent);

function initHeaderDropdowns() {
  var navItems = document.querySelectorAll('.header__main-nav .horizontal-list__item[aria-haspopup="true"]');

  navItems.forEach(function (item) {
    var menu = null;

    Array.prototype.forEach.call(item.children, function (child) {
      if (child.classList.contains('dropdown-menu') || child.classList.contains('mega-menu')) {
        menu = child;
      }
    });

    if (!menu) {
      return;
    }

    item.addEventListener('mouseenter', function () {
      menu.setAttribute('aria-hidden', 'false');
      item.classList.add('is-expanded');
    });

    item.addEventListener('mouseleave', function (event) {
      if (item.contains(event.relatedTarget)) {
        return;
      }

      menu.setAttribute('aria-hidden', 'true');
      item.classList.remove('is-expanded');
    });

    item.addEventListener('focusin', function () {
      menu.setAttribute('aria-hidden', 'false');
      item.classList.add('is-expanded');
    });

    item.addEventListener('focusout', function (event) {
      if (item.contains(event.relatedTarget)) {
        return;
      }

      menu.setAttribute('aria-hidden', 'true');
      item.classList.remove('is-expanded');
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderDropdowns);
} else {
  initHeaderDropdowns();
}
